/* artidomo Hauptmenü – Verhalten für Desktop-Aufklapp-Bereiche und Handy-Schublade.
   Ohne Fremdbibliotheken. Alle Ereignisse hängen per Delegation an document, damit alles
   auch nach einem Neuaufbau der Section im Theme-Editor weiter funktioniert. */
(function () {
  'use strict';
  if (window.__adhmInit) return;
  window.__adhmInit = true;
  document.documentElement.classList.add('adhm-js');

  var DESKTOP = window.matchMedia('(min-width: 1025px)');
  var ICON_RECHTS = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
  var ICON_LINKS = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var ICON_HERZ = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>';
  var ICON_EXTERN = '<svg class="adhm-extern" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>';
  var ICON_HILFE = '<svg class="adhm-hilfe" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>';
  var ICON_PERSON ='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function kinder(el, selektor) {
    return Array.prototype.filter.call(el.children, function (k) { return k.matches(selektor); });
  }

  /* ---------- Desktop ---------- */
  var openLi = null, tOpen = 0, tClose = 0;
  // Mausrichtung: Wer von einem offenen Punkt nach unten Richtung Aufklapp-Bereich fährt,
  // soll unterwegs keinen Punkt der zweiten Zeile öffnen (Wechsel-Bremse).
  var lastX = 0, lastY = 0, headingDown = false;

  function panelVon(li) { return kinder(li, '.adhm-panel')[0]; }
  function knopfVon(li) { return kinder(li, '.adhm-btn')[0]; }

  function openItem(li) {
    if (openLi === li) return;
    closeItem();
    var panel = panelVon(li);
    if (!panel) return;
    openLi = li;
    li.classList.add('is-open');
    knopfVon(li).setAttribute('aria-expanded', 'true');
    if (li.classList.contains('adhm-item--breit')) {
      // Breiter Bereich beginnt direkt unter der Zeile des Punkts und überdeckt die Zeile darunter
      panel.style.top = (li.offsetTop + li.offsetHeight) + 'px';
    } else {
      var nav = li.closest('.adhm').getBoundingClientRect();
      var r = li.getBoundingClientRect();
      panel.classList.toggle('is-rechts', r.left + 290 > nav.right);
      panel.classList.toggle('is-gespiegelt', r.left + 290 + 460 > nav.right);
    }
  }
  function closeItem() {
    if (!openLi) return;
    if (document.documentElement.contains(openLi)) {
      openLi.classList.remove('is-open');
      var b = knopfVon(openLi);
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    openLi = null;
  }

  document.addEventListener('mousemove', function (e) {
    var dx = e.clientX - lastX, dy = e.clientY - lastY;
    if (Math.abs(dx) + Math.abs(dy) < 3) return;
    headingDown = dy > 0 && dy >= Math.abs(dx) * 0.5;
    lastX = e.clientX; lastY = e.clientY;
  }, { passive: true });

  document.addEventListener('mouseover', function (e) {
    if (!DESKTOP.matches || !e.target.closest) return;
    var li = e.target.closest('.adhm-item');
    if (!li || (e.relatedTarget && li.contains(e.relatedTarget))) return;
    clearTimeout(tClose);
    clearTimeout(tOpen);
    if (li === openLi) return;
    var delay = !openLi ? 90 : (headingDown ? 400 : 120);
    tOpen = setTimeout(function () { openItem(li); }, delay);
  });
  document.addEventListener('mouseout', function (e) {
    if (!DESKTOP.matches || !e.target.closest) return;
    var li = e.target.closest('.adhm-item');
    if (!li || (e.relatedTarget && li.contains(e.relatedTarget))) return;
    if (li !== openLi) clearTimeout(tOpen);
    clearTimeout(tClose);
    tClose = setTimeout(closeItem, 250);
  });

  /* ---------- Handy-Schublade ---------- */
  var stack = [];

  function schublade() { return document.getElementById('adhm-drawer'); }

  function knoten(li) {
    var link = kinder(li, '.adhm-link')[0];
    var bild = link.querySelector('img');
    var schild = link.querySelector('.adhm-lb');
    var liste = kinder(li, '.adhm-kids')[0];
    return {
      t: link.querySelector('.adhm-txt').textContent.trim(),
      u: link.tagName === 'A' ? link.getAttribute('href') : null,
      lb: schild ? { text: schild.textContent.trim(), cls: schild.className } : null,
      img: bild ? bild.getAttribute('src') : null,
      logo: bild ? bild.classList.contains('adhm-logo') : false,
      c: liste ? kinder(liste, '.adhm-node').map(knoten) : []
    };
  }
  function hauptknoten(li) {
    if (li.classList.contains('adhm-item--link')) {
      var a = kinder(li, 'a.adhm-btn')[0];
      return { t: a.querySelector('.adhm-txt').textContent.trim(), u: a.getAttribute('href'), nw: a.getAttribute('target') === '_blank', c: [] };
    }
    var panel = panelVon(li);
    var liste = panel ? kinder(panel, '.adhm-kids')[0] : null;
    var cta = panel ? panel.querySelector('.adhm-pfoot a.adhm-cta') : null;
    var plink = panel ? panel.querySelector('.adhm-pfoot a.adhm-plink') : null;
    return {
      t: knopfVon(li).querySelector('.adhm-txt').textContent.trim(),
      u: null,
      c: liste ? kinder(liste, '.adhm-node').map(knoten) : [],
      cta: cta ? { t: cta.querySelector('.adhm-txt').textContent.trim(), u: cta.getAttribute('href'), nw: cta.getAttribute('target') === '_blank' } : null,
      plink: plink ? { t: plink.querySelector('.adhm-txt').textContent.trim(), u: plink.getAttribute('href'), nw: plink.getAttribute('target') === '_blank' } : null
    };
  }
  function wurzel() {
    var nav = document.getElementById('adhm');
    var c = [], heads = {};
    if (!nav) return { t: 'Menü', c: c, heads: heads };
    var infoTitel = nav.getAttribute('data-info-titel') || '';
    Array.prototype.forEach.call(nav.querySelectorAll('.adhm-row'), function (row) {
      var label = kinder(row, '.adhm-label')[0];
      var normal = [], rechts = [];
      // Info-Punkte (rechtsbündige Hauptpunkte) kommen auf dem Handy unter eine eigene Überschrift,
      // rechtsbündige einfache Links bleiben in der Gruppe ihrer Zeile.
      kinder(row, '.adhm-item').forEach(function (li) {
        (li.classList.contains('adhm-item--info') ? rechts : normal).push(li);
      });
      if (label && normal.length) heads[c.length] = { text: label.textContent.trim(), cls: row.classList.contains('adhm-row--2') ? 'z2' : 'z1' };
      normal.forEach(function (li) { c.push(hauptknoten(li)); });
      if (rechts.length) {
        if (infoTitel) heads[c.length] = { text: infoTitel, cls: 'info' };
        rechts.forEach(function (li) { c.push(hauptknoten(li)); });
      }
    });
    return { t: 'Menü', c: c, heads: heads };
  }

  function ansicht(node, istWurzel) {
    var v = document.createElement('div');
    v.className = 'adhm-mv' + (istWurzel ? ' adhm-mv--root' : '');
    v._node = node;
    var html = istWurzel ? '' : '<button type="button" class="adhm-mback">' + ICON_LINKS + '<span>' + esc(node.t) + '</span></button>';
    html += '<ul>';
    if (!istWurzel && node.u && node.c.length) {
      html += '<li><a class="adhm-mrow adhm-mall" href="' + esc(node.u) + '"><span class="adhm-ml">Alles aus „' + esc(node.t) + '“ ansehen</span></a></li>';
    }
    node.c.forEach(function (n, i) {
      if (node.heads && node.heads[i]) {
        html += '<li class="adhm-mgroup adhm-mgroup--' + node.heads[i].cls + '"><span>' + esc(node.heads[i].text) + '</span></li>';
      }
      var inhalt;
      if (n.img && n.logo) inhalt = '<img class="adhm-mlogo" src="' + esc(n.img) + '" alt=""><span class="adhm-sr">' + esc(n.t) + '</span>';
      else if (n.img) inhalt = '<img class="adhm-mthumb" src="' + esc(n.img) + '" alt=""><span>' + esc(n.t) + '</span>';
      else inhalt = '<span>' + esc(n.t) + '</span>';
      if (n.lb) inhalt += '<span class="' + esc(n.lb.cls) + '">' + esc(n.lb.text) + '</span>';
      inhalt = '<span class="adhm-ml">' + inhalt + '</span>';
      if (n.c.length) html += '<li><button type="button" class="adhm-mrow" data-i="' + i + '">' + inhalt + ICON_RECHTS + '</button></li>';
      else if (n.u && n.nw) html += '<li><a class="adhm-mrow" href="' + esc(n.u) + '" target="_blank" rel="noopener">' + inhalt + ICON_EXTERN + '</a></li>';
      else if (n.u) html += '<li><a class="adhm-mrow" href="' + esc(n.u) + '">' + inhalt + '</a></li>';
      else html += '<li><span class="adhm-mrow">' + inhalt + '</span></li>';
    });
    html += '</ul>';
    if (node.cta) {
      html += '<div class="adhm-mcta"><a class="adhm-cta" href="' + esc(node.cta.u) + '"' + (node.cta.nw ? ' target="_blank" rel="noopener"' : '') + '><span>' + esc(node.cta.t) + '</span>' + (node.cta.nw ? ICON_EXTERN : '') + '</a></div>';
    }
    if (node.plink) {
      html += '<div class="adhm-mplink"><a class="adhm-plink" href="' + esc(node.plink.u) + '"' + (node.plink.nw ? ' target="_blank" rel="noopener"' : '') + '>' + ICON_HILFE + '<span>' + esc(node.plink.t) + '</span>' + (node.plink.nw ? ICON_EXTERN : '') + '</a></div>';
    }
    if (istWurzel) {
      var d = schublade();
      html += '<ul class="adhm-mextra">'
        + '<li><a href="' + esc(d.getAttribute('data-wunsch-url')) + '">' + ICON_HERZ + 'Wunschliste</a></li>'
        + '<li><a href="' + esc(d.getAttribute('data-konto-url')) + '">' + ICON_PERSON + esc(d.getAttribute('data-konto-text')) + '</a></li>'
        + '</ul>';
    }
    v.innerHTML = html;
    return v;
  }

  function neuAufbauen() {
    var d = schublade();
    var views = d.querySelector('.adhm-views');
    views.innerHTML = '';
    stack = [];
    var w = ansicht(wurzel(), true);
    w.classList.add('is-in');
    views.appendChild(w);
    stack.push(w);
  }
  function push(node) {
    var d = schublade();
    var v = ansicht(node, false);
    d.querySelector('.adhm-views').appendChild(v);
    var vorher = stack[stack.length - 1];
    stack.push(v);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        v.classList.add('is-in');
        if (vorher) vorher.classList.add('is-left');
        var back = v.querySelector('.adhm-mback');
        if (back) back.focus({ preventScroll: true });
      });
    });
  }
  function pop() {
    if (stack.length < 2) return;
    var v = stack.pop();
    var vorher = stack[stack.length - 1];
    v.classList.remove('is-in');
    vorher.classList.remove('is-left');
    setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 300);
  }
  function knoepfe(offen) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-adhm-open]'), function (b) {
      b.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
  }
  function oeffnen() {
    var d = schublade();
    if (!d) return;
    neuAufbauen();
    d.hidden = false;
    document.documentElement.classList.add('adhm-lock');
    knoepfe(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('is-open');
        var x = d.querySelector('.adhm-close');
        if (x) x.focus({ preventScroll: true });
      });
    });
  }
  function schliessen() {
    var d = schublade();
    document.documentElement.classList.remove('adhm-lock');
    knoepfe(false);
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 300);
  }

  /* ---------- Klicks und Tasten ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var btn = t.closest('button.adhm-btn');
    if (btn) {
      var li = btn.closest('.adhm-item');
      clearTimeout(tOpen);
      if (openLi === li) closeItem(); else openItem(li);
      return;
    }
    if (openLi && !t.closest('.adhm')) closeItem();

    if (t.closest('[data-adhm-open]')) { e.preventDefault(); oeffnen(); return; }
    if (t.closest('[data-adhm-close]')) { schliessen(); return; }
    if (t.closest('.adhm-mback')) { pop(); return; }
    var zeile = t.closest('button.adhm-mrow');
    if (zeile) {
      var v = zeile.closest('.adhm-mv');
      if (v && v._node) push(v._node.c[+zeile.getAttribute('data-i')]);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openLi) { var b = knopfVon(openLi); closeItem(); if (b) b.focus(); }
    var d = schublade();
    if (d && !d.hidden) schliessen();
  });
  var beiWechsel = function () { closeItem(); schliessen(); };
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', beiWechsel);
  else if (DESKTOP.addListener) DESKTOP.addListener(beiWechsel);

  // Theme-Editor: Section wurde neu aufgebaut → alten Zustand verwerfen
  document.addEventListener('shopify:section:load', function () { openLi = null; stack = []; document.documentElement.classList.remove('adhm-lock'); });
})();
